<div class="container">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="clearfix">
        <h1 class="float-left display-3 mr-4">500</h1>
        <h4 class="pt-3">{{ 'admin.alerts.problemMsg' | translate }}</h4>
        <div>
          <p class="text-muted" *ngIf="errorMessage">{{ errorMessage }}</p>
          <p class="text-muted" *ngIf="!errorMessage">
            {{ 'admin.alerts.pageUnavailable' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
